import { render, staticRenderFns } from "./upfile.vue?vue&type=template&id=57df3cec&scoped=true&"
import script from "./upfile.vue?vue&type=script&lang=js&"
export * from "./upfile.vue?vue&type=script&lang=js&"
import style0 from "./upfile.vue?vue&type=style&index=0&id=57df3cec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57df3cec",
  null
  
)

export default component.exports